import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_code_editor extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_code_editor">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Code Editor</h2>
              <p>
                Record code editor component allows users to edit code snippets in the browser.
              </p>
              <p>
                Format code keyboard shortcut Ctrl + B on PC and Command + B on Mac
              </p>
              <p>
                Fullscreen keyboard shortcut Ctrl + Enter on PC and Mac
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_code_editor"}
                name={"code editor"}
                dataNameDefault={
                  '"text_my_field" or "object_my_obj.text_my_field"'
                }
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={false}
                properties={[
                  {
                    property: "language",
                    description:
                      "The programming language the code editor is expecting.",
                    defaults: '"csharp", "css", "elixir", "golang", "handlebars", "html", "java", "javascript", "json", "markdown", "mssql", "python", "ruby", "sass", "typescript", "xml" default is "json"'
                  },
                  {
                    property: "theme",
                    description:
                      "The colors used in the editor.",
                    defaults: '"dark", "light" default is "dark"'
                  },
                  {
                    property: "height",
                    description:
                      "Height of the code editor.",
                    defaults: '50-1000, "auto" default 400'
                  },
                  {
                    property: "font_size",
                    description:
                      "Font size used by code editor.",
                    defaults: '10-40, default 20'
                  },
                  {
                    property: "font_size",
                    description:
                      "Font size used by code editor.",
                    defaults: '10-40, default 20'
                  },
                  {
                    property: "fullscreen_mode",
                    description:
                      "Allow users to make the code editor fullscreen using Ctrl+Enter.",
                    defaults: '"fullscreen", "window", "disabled", default "fullscreen"'
                  }, 
                  {
                    property: "autocomplete",
                    description:
                      "Provides suggestions when writing code.",
                    defaults: 'true, false default is true'
                  },
                  {
                    property: "validate",
                    description:
                      "Validate html and json code before saving. Validate will ignore other languages.",
                    defaults: 'true, false default is true'
                  },
                ]}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Code Editor Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple HTML Code Editor</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_code_editor"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_my_html"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My HTML Editor"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"font_size"</span>:{" "}
                  <span className="jsonP">26</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"language"</span>:{" "}
                  <span className="jsonY">"html"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"theme"</span>:{" "}
                  <span className="jsonY">"solarized_light"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"autocomplete"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"height"</span>:{" "}
                  <span className="jsonP">600</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_code_editor;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_code_editor.js